"use client";

import translations from "@/lib/translations.json";
import { ClipboardList, Eye, ShieldAlert } from "lucide-react";
import { useWebsiteLang } from "../context/website-lang-context";

const icons = [ClipboardList, ShieldAlert, Eye];

export default function Benefits() {
  const { lang } = useWebsiteLang();
  const t = translations[lang].website.benefits;

  return (
    <section className="relative py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-16 text-center">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-amber-500/20 px-4 py-1.5 text-xs font-medium text-amber-400 glass">
            <span className="h-1.5 w-1.5 rounded-full bg-amber-500 animate-pulse-slow" />
            {t.badge}
          </div>
          <h2 className="mb-4 text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
            {t.titlePrefix}{" "}
            <span className="text-gradient-amber">{t.titleHighlight}</span>
          </h2>
          <p className="mx-auto max-w-2xl text-base md:text-lg text-white/50">
            {t.subtitle}
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-3 lg:gap-8">
          {t.items.map((benefit, index) => {
            const Icon = icons[index];
            return (
              <div
                key={benefit.title}
                className="group relative rounded-2xl border border-white/5 bg-white/[0.03] p-6 transition-all duration-300 hover:border-white/10 hover:bg-white/[0.04] sm:p-8"
              >
                <div
                  className={`mb-6 flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br ${benefit.gradient} shadow-lg`}
                >
                  <Icon size={22} className="text-white" />
                </div>
                <h3 className="mb-3 text-xl font-bold text-white">
                  {benefit.title}
                </h3>
                <p className="mb-6 text-sm leading-relaxed text-white/50">
                  {benefit.description}
                </p>
                <div className="border-t border-white/5 pt-4">
                  <div className="flex items-end gap-2">
                    <span
                      className={`bg-gradient-to-r ${benefit.gradient} bg-clip-text text-3xl font-extrabold text-transparent`}
                    >
                      {benefit.stat}
                    </span>
                    <span className="pb-1 text-xs text-white/40">
                      {benefit.statLabel}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
